import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    return (
      <div className="mb-0">
        {label && (
          <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1" htmlFor={props.id}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`
            w-full px-3 py-2 border rounded-lg text-sm sm:text-base text-slate-900 placeholder-slate-400
            focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
            transition-colors duration-200
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-300'}
            ${className}
          `}
          {...props}
        />
        {error && <span className="text-xs sm:text-sm text-red-600 mt-1 block">{error}</span>}
        {helperText && !error && <span className="text-xs sm:text-sm text-slate-500 mt-1 block">{helperText}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
